import { Component, OnInit } from '@angular/core';
import { NgbModule, NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AuthControllerService } from '../Services/auth-controller.service';
import { DivisionService } from '../Services/division.service';
import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';
import { ActivatedRoute, Router } from '@angular/router';
import { MyModalService } from '../Services/modal-service.service';

@Component({
  selector: 'app-user-register',
  templateUrl: './user-register.component.html',
  styleUrls: ['./user-register.component.css']
})
export class UserRegisterComponent implements OnInit {
  logininfo: Logininfo = this.auth.loginID;
  divisions;
  auths;

  userinfo: any = {
    user_code: null,
    user_family_name: '',
    user_name: '',
    division_code: 0,
    authority_code: 0,
    mail_address: '',
    managed: 1,
    is_sales: 0,
    is_construction: 0,
    is_design: 0,
    is_office: 0,
    del_customer: 0
  };
  deldata: any;
  error_msg: string = '';
  info_msg: string = '';
  modalReference: NgbModalRef;


  constructor(
    private AuthControll: AuthControllerService,
    private divisionService: DivisionService,
    public auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: MyModalService,
    private modal: NgbModal,

  ) { }

  ngOnInit() {
    this.error_msg = '';
    this.info_msg = '';
    var user_code = +this.route.snapshot.paramMap.get('user_code');
    this.divisionService.getDivisionList().subscribe(result => {
      this.divisions = result;
    });
    this.getPostList();
    //console.log('ngOnInit');
    if (user_code > 0) {
      // ユーザ情報取得
      this.auth.getUser(user_code).subscribe((res) => {
        //console.log('getUser', res);
        this.userinfo = res;
      });
    }
  }

  //役職リスト読み込み
  getPostList() {
    this.AuthControll.getAuthList().subscribe(result => {
      this.auths = result;
      //console.log('getPostList', this.auths);
    });
  }

  regist() {
    this.error_msg = '';
    this.info_msg = '';
    this.auth.userRegister(this.userinfo).subscribe((res) => {
      if (res['error'] == 1) {
        this.error_msg = '登録に失敗しました';
        this.info_msg = '';
      } else if (res['error'] == 2) {
        this.error_msg = '既に登録されています';
        this.info_msg = '';
      } else if (res['error'] == 3) {
        this.error_msg = 'パスワードを設定してください';
        this.info_msg = '';
      } else {
        this.error_msg = '';
        this.info_msg = '登録しました';
        this.auth.getUser(res['user_code']).subscribe((res) => {
          this.userinfo = res;
        });
      }
    })
  }
  async clearPassword() {
    this.error_msg = '';
    this.info_msg = '';
    const res = await this.modalService.confirm('確認', 'パスワードをクリアしてもよろしいですか？');
    if (!res) {
      return;
    }
    this.auth.resetPassword(this.userinfo.user_code).subscribe((res) => {
      if (res['error'] == 1) {
        this.error_msg = 'パスワードのクリアに失敗しました';
        this.info_msg = '';
      } else {
        this.error_msg = '';
        this.info_msg = 'パスワードをクリアしました。';
      }
    })
  }
  goback() {
    this.router.navigate(['/user-management']);
  }
  delete(delmodal) {
    this.deldata = this.userinfo;
    this.modalReference = this.modal.open(delmodal, { centered: true });
    this.modalReference.result.then((result) => { }, (reason) => { });
  }
  runDelete() {
    this.error_msg = '';
    this.info_msg = '';
    if (this.deldata.del_chk != '1') {
      //モーダル閉じる
      this.modalReference.close();
    } else {
      if (this.deldata.user_code > 0) {
        this.auth.userDelete(this.deldata).subscribe(res => {
          if (res['error'] == 0) {
            this.info_msg = "ユーザ情報を削除しました";
            this.error_msg = "";
          } else {
            this.info_msg = "";
            this.error_msg = "ユーザ情報の削除に失敗しました";
          }
          //モーダル閉じる
          this.deldata.del_chk = '';
          this.modalReference.close();
        });
      }
    }

  }
  authChange() {
    if (this.userinfo.authority_code == 1) {
      this.userinfo.managed = 0;
      this.userinfo.is_sales = 0;
      this.userinfo.is_construction = 0;
    } else if (this.userinfo.authority_code == 2) {
      this.userinfo.managed = 0;
      this.userinfo.is_sales = 0;
      this.userinfo.is_construction = 0;
    } else if (this.userinfo.authority_code == 5) {
      this.userinfo.managed = 1;
      this.userinfo.is_sales = 0;
      this.userinfo.is_construction = 1;
    } else {
      this.userinfo.managed = 1;
      this.userinfo.is_sales = 1;
      this.userinfo.is_construction = 0;
    }
  }
}
